<template>
  <div id="app-org">
    <div class="org-box">
      <div class="org-top">
        <span></span>
        <div class="top-l">
          <p>ORGANIZATION</p>
          <h3>公益组织</h3>
        </div>
      </div>
      <div class="org-bottom">
        <ul>
          <router-link tag="li" v-if="newsId" class="fanbu" :to="{ name: 'fanbu',query: { id: newsId }}">
            <div class="act-bottom">
              <p>反哺计划</p>
              <h3>互帮互助 共同成长 反哺家乡 回馈社会</h3>
            </div>
          </router-link>
          <li class="fanbu" v-else>
            <div class="act-bottom">
              <p>反哺计划</p>
              <h3>互帮互助 共同成长 反哺家乡 回馈社会</h3>
            </div>
          </li>
          <router-link tag="li" class="xiehui" :to="{ name: 'organization'}">
            <div class="act-bottom">
              <p>志愿者协会</p>
              <h3>让公益成为一种生活习惯</h3>
            </div>
          </router-link>
          <li>
            <div class="volunteer-box">
              <div class="volunteer-heard">
                <p
                  v-for="(item,index) in vList"
                  :key="index"
                  :class="{active:borderShow==item.id}"
                  @click="getBorder(item.id)"
                >{{item.title}}</p>
              </div>
              <WtDataList
                v-model="data.list"
                :pageSize="8"
                :url="$url.volunteer.ranking"
                :search="search"
                :isPage="false"
              >
                <div class="volunteer-list" slot="list">
                  <ul>
                    <li v-for="(item,index) in data.list" :key="index">
                      <i>{{index+1}}</i>
                      <p>{{item.name}}</p>
                      <span>{{item.service_length}} h</span>
                    </li>
                  </ul>
                </div>
              </WtDataList>
            </div>
            <div class="time-box">
              <div class="time-l">
                <h3>{{volunteerData.volunteer_count}}</h3>
                <p>志愿者总人数</p>
              </div>
              <div class="time-r">
                <span>{{volunteerData.service_sum}}</span>
                <i>h</i>
                <p>志愿者服务总时长</p>
              </div>
            </div>
          </li>
        </ul>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  props: {
    //请求的url地址
    newsId: {
      type: Number,
      default() {
        return 0;
      }
    }
  },
  data() {
    return {
      volunteerData: {
        service_sum: 0,
        volunteer_count: 0
      },
      search: {},
      newsList: [],
      data: {
        list: []
      },
      ifSearch: {
        if_recommend: 1, //首页推荐
        if_show: 1, //前台展示
        type: 4
      },
      navData: [
        {
          id: 1,
          title: "顺丰公益动态"
        },
        {
          id: 2,
          title: "媒体关注"
        },
        {
          id: 3,
          title: "公益月报"
        }
      ],
      listyle: 1,
      orgList: [
        {
          id: 1,
          title: "顺丰反哺计划",
          time: "基金会为反哺计划团队提供活动方案指导及活动经费支持"
        },
        {
          id: 1,
          title: "志愿者协会",
          time: "基金会为反哺计划团队提供活动方案指导及活动经费支持"
        }
      ],
      vList: [
        {
          id: 1,
          title: "志愿者个人排名"
        }
        // {
        //   id: 2,
        //   title: "志愿者团队排名"
        // }
      ],
      borderShow: 1
    };
  },
  methods: {
    getStyle(id) {
      this.listyle = id;
    },
    getBorder(id) {
      this.borderShow = id;
    }
  },
  mounted() {
    //获取志愿者总人数、总服务时长
    this.$db.post(this.$url.volunteer.statistics).then(resp => {
      this.volunteerData = resp.data;
      this.$db.setPageSize(2);
      this.$db.setSearch(this.ifSearch);
      this.$db.list(this.$url.news.list, false).then(resp => {
        this.newsList = resp.data;
      });
    });
  }
};
</script>

<style lang="scss" scoped>
#app-org {
  width: 100%;
  // margin-bottom: 45px;
  // background-color: #f5f5f5;
}
.org-box {
  max-width: 1300px;
  margin: 0 auto;
  padding: 45px 0;
  .org-top {
    position: relative;
    padding-left: 18px;
    display: flex;
    justify-content: space-between;
    margin-bottom: 45px;
    > span {
      width: 2px;
      // height: 55px;
      height: 100%;
      background-image: linear-gradient(
          0deg,
          #8ec31f 0%,
          #4eb875 10%,
          #2dbadc 20%,
          #258bcc 31%,
          #273d96 43%,
          #944496 50%,
          #bb4695 53%,
          #dc0536 65%,
          #e83a16 76%,
          #fcd475 89%,
          #d7de00 100%
        ),
        linear-gradient(#c12411, #c12411);
      position: absolute;
      left: 0;
      top: 0;
    }
    .top-l {
      > p {
        font-size: 24px;
        font-weight: normal;
        color: #999999;
      }
      > h3 {
        font-size: 24px;
        font-weight: 500;
        color: #333;
      }
    }
    .top-r {
      padding-right: 25px;
      position: relative;
      width: 308px;
      > ul {
        display: flex;
        justify-content: space-between;
        position: absolute;
        top: 50%;
        left: 0;
        transform: translateY(-50%);
        > li {
          list-style: none;
          margin-right: 30px;
          font-size: 15px;
          font-weight: normal;
          color: #333333;
          padding-bottom: 3px;
          cursor: pointer; // &:last-child { // margin-right: 0; // }
          &.active {
            border-bottom: 2px solid #e83a16;
            color: #e83a16;
          }
        }
      }
      > i {
        width: 25px;
        height: 25px;
        position: absolute;
        top: 50%;
        right: 0;
        transform: translateY(-50%);
        background: url(../../assets/images/more.png) no-repeat;
        background-size: 100% 100%;
        &:hover {
          background: url(../../assets/images/more1.png) no-repeat;
          background-size: 100% 100%;
        }
      }
    }
  }
  .org-bottom {
    width: 100%;
    > ul {
      display: flex;
      justify-content: space-between;
      .fanbu {
        background: url(../../assets/images/fanbu.jpeg) no-repeat;
        background-size: 100% 100%;
      }
      .xiehui {
        background: url(../../assets/images/xiehui.jpeg) no-repeat;
        background-size: 100% 100%;
      }
      > li {
        cursor: pointer;
        list-style: none;
        width: 400px;
        height: 573px;
        box-shadow: 0px 6px 19px 0px rgba(11, 2, 5, 0.09);
        position: relative;
        border-radius: 6px;
        overflow: hidden;
        &:last-child {
          background: none;
          background-color: #e83a16;
          box-shadow: 2px 3px 27px 0px rgba(11, 2, 5, 0.1);
          .volunteer-box {
            padding: 0 36px;
            .volunteer-heard {
              > p {
                font-size: 16px;
                font-weight: normal;
                color: #ffffff;
                padding: 14px 0;
                cursor: pointer;
                &.active {
                  border-bottom: 1px solid #fff;
                }
              }
            }
            .volunteer-list {
              > ul {
                padding-top: 0px;
                max-height: 425px;
                > li {
                  list-style: none;
                  display: flex;
                  justify-content: space-between;
                  padding: 15px 0;
                  padding-left: 40px;
                  position: relative;
                  border-bottom: 1px solid #ea4523;
                  &:nth-child(1) {
                    > i {
                      background-color: #ed902c;
                    }
                  }
                  &:nth-child(2) {
                    > i {
                      background-color: #f8b92b;
                    }
                  }
                  &:nth-child(3) {
                    > i {
                      background-color: #fcd475;
                    }
                  }
                  &:last-child {
                    border-bottom: none;
                  }
                  > i {
                    width: 25px;
                    height: 25px;
                    background-color: #e23815;
                    border-radius: 50%;
                    font-size: 16px;
                    font-style: normal;
                    line-height: 25px;
                    text-align: center;
                    color: #ffffff;
                    position: absolute;
                    left: 0;
                    top: 50%;
                    transform: translateY(-50%);
                  }
                  > p {
                    font-size: 16px;
                    font-weight: normal;
                    color: #ffffff;
                  }
                  > span {
                    font-size: 16px;
                    font-weight: normal;
                    color: #fcd475;
                  }
                }
              }
            }
          }
          .time-box {
            background-color: #f44521;
            padding: 20px 50px;
            display: flex;
            justify-content: space-between;
            margin-top: 4px;
            .time-l {
              > h3 {
                font-size: 30px;
                font-weight: normal;
                color: #ffffff;
                text-align: center;
              }

              > p {
                font-size: 14px;
                color: #ffffff;
                text-align: center;
              }
            }
            .time-r {
              // vertical-align:top;
              > span {
                font-size: 30px;
                font-weight: normal;
                color: #ffffff;
                text-align: center;
              }
              > i {
                font-size: 14px;
                color: #ffffff;
                font-style: normal;
                position: relative;
                top: 50%;
                vertical-align: top;
              }
              > p {
                font-size: 14px;
                color: #ffffff;
                text-align: center;
              }
            }
          }
        }
        .act-bottom {
          padding: 35px 52px 30px 40px;
          width: calc(100% - 92px);
          position: absolute;
          left: 0;
          bottom: 0;
          background-color: rgba($color: #000000, $alpha: 0.3);
          > p {
            font-size: 30px;
            font-weight: normal;
            color: #ffffff;
            margin-bottom: 14px;
          }
          > h3 {
            font-size: 16px;
            font-weight: normal;
            color: #ffffff;
            line-height: 26px;
          }
        }
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/view/Index/volunteer.vue